module.exports = __webpack_public_path__ + "static/media/juridico.2186c7d2.svg";